import { Link } from 'react-router-dom';

const stats = [
  { value: '12,000+', label: '影视作品资料' },
  { value: '3,600+', label: '资讯文章' },
  { value: '68', label: '覆盖国家与地区' },
  { value: '9.2', label: '平均用户评分' },
];

export default function SiteIntro() {
  return (
    <section className="w-full bg-foreground-950 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-block rounded-full bg-primary-500/15 px-3 py-1 text-xs font-medium text-accent-400">
              关于红杏影视
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              一个专注于影视资讯与作品资料的现代门户
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-300 md:text-base">
              红杏影视汇聚电影、电视剧等丰富影视资源介绍与最新行业动态，以清晰的结构与舒适的阅读体验，帮助每一位影视爱好者快速了解作品信息、掌握影视圈热点。我们坚持内容的真实与丰富，让选片这件事变得简单而愉快。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {['影视资讯', '作品推荐', '分类筛选', '深度影评'].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-foreground-700 px-3 py-1 text-xs text-foreground-300"
                >
                  {tag}
                </span>
              ))}
            </div>
            <Link
              to="/about"
              className="mt-7 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
            >
              了解更多
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-foreground-800 bg-foreground-900 p-5 text-center md:p-6"
              >
                <p className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">{stat.value}</p>
                <p className="mt-2 text-xs text-foreground-400 md:text-sm">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}